import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#E5252A",
      d: "M19.045 7.897v13.138a2.215 2.215 0 0 1-2.215 2.215H3.17a2.215 2.215 0 0 1-2.215-2.215V2.965C.955 1.742 1.946.75 3.17.75h9.15z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#ED676A",
      d: "M19.045 7.897h-5.249a1.477 1.477 0 0 1-1.477-1.477V.75z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M5.675 16.55v1.498H4.612v-4.41h1.76q.506 0 .895.186.39.186.603.53t.214.78q0 .645-.463 1.032-.461.384-1.268.385zm0-.82h.697q.309.001.471-.154.162-.153.162-.436a.71.71 0 0 0-.167-.494.6.6 0 0 0-.455-.188h-.708zM8.649 18.048v-4.41h1.42q.585 0 1.052.265.465.264.728.749.262.482.264 1.081v.204q0 .605-.255 1.085t-.722.752q-.466.269-1.036.274zm1.063-3.59v2.772h.369q.459 0 .702-.326.247-.325.247-.967v-.19q0-.641-.247-.964-.244-.325-.714-.325zM15.437 16.291h-1.715v1.757H12.66v-4.41h2.949v.82h-1.887v1.016h1.715z"
    }, null, -1)
  ]))]))
}
export default { render: render }